import React from 'react';
import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <CssBaseline />
            <App />
        </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename="/edu/Game">
            <CssBaseline />
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
*/
